/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    "./pages/**/*.{js,ts,jsx,tsx}",
    "./components/**/*.{js,ts,jsx,tsx}",
    "./src/**/*.{js,ts,jsx,tsx}",
    'node_modules/flowbite-react/**/*.{js,jsx,ts,tsx}',
    "node_modules/react-tailwindcss-datepicker/dist/index.esm.js",
  ],
  theme: {
    // fontSize: {
    //   xs: '0.75rem',
    //   sm: '0.875rem',
    //   // sm: '0.938rem',
    //   base: '1rem',
    //   lg: '1.125rem',
    //   xl: '1.5rem',
    //   '2xl': '1.75rem',
    //   '3xl': '1.875rem',
    //   '4xl': '2.25rem',
    //   '5xl': '3rem',
    // },
    boxShadow: {
      // Flat by default; elevation reserved for floating UI
      0: "none",
      none: "none",
      pill: "0 1px 3px rgba(16,24,40,.08), 0 1px 2px rgba(16,24,40,.04)",
      card: "none",
      float: "0 14px 36px rgba(16,24,40,.13), 0 3px 8px rgba(16,24,40,.06)",
      1: "0 1px 1px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)",
      2: "0 2px 6px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.06)",
    },

    fontFamily: {
      sans: ["Inter", "ui-sans-serif", "system-ui", "Segoe UI", "Roboto", "Helvetica", "Arial", "sans-serif"],
      mono: ["ui-monospace", "SFMono-Regular", "Menlo", "Monaco", "Consolas", "Liberation Mono", "Courier New", "monospace"],
    },

    fontSize: {
      // CFO-friendly hierarchy (no oversized marketing type)
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["0.9375rem", { lineHeight: "1.5rem" }], // slightly tighter than 1rem
      lg: ["1.0625rem", { lineHeight: "1.625rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
    },
    width: {
      '64': '16rem',
      '100': '25rem',
      '128': '32rem',
      '164': '41rem',
    },
    height: {
      '8plus': '32px',
    },
    borderRadius: {
      none: "0",
      sm: "0.375rem",    // 6px
      md: "0.625rem",    // 10px
      ctrl: "0.6875rem", // 11px  buttons/inputs/nav items
      tab: "0.5625rem",  // 9px
      seg: "0.8125rem",  // 13px  AI Assistant / tab track
      lg: "0.75rem",     // 12px
      card: "1rem",      // 16px  units
      xl: "1.25rem",
      full: "9999px",
    },
    colors: {
      'transparent': 'transparent',
      'background': 'white',
      'background-grey': '#F9FAFC',
      'backgroundgrey': '#F9FAFC',
      'current': 'currentColor',
      'lightblue1': '#035388',
      'lightblue2': '#0B69A3',
      'lightblue3': '#127FBF',
      'lightblue4': '#1992D4',
      'lightblue5': '#2BB0ED',
      'lightblue6': '#40C3F7',
      'lightblue7': '#5ED0FA',
      'lightblue8': '#81DEFD',
      'lightblue9': '#B3ECFF',
      'lightblue10': '#E3F8FF',
      'coolgrey1': '#1F2933',
      'coolgrey2': '#323F4B',
      'coolgrey3': '#3E4C59',
      'coolgrey4': '#52606D',
      'coolgrey5': '#616E7C',
      'coolgrey6': '#7B8794',
      'coolgrey7': '#9AA5B1',
      'coolgrey8': '#CBD2D9',
      'coolgrey9': '#E4E7EB',
      'coolgrey10': '#F5F7FA',
      'pink1': '#620042',
      'pink2': '#870557',
      'pink3': '#A30664',
      'pink4': '#BC0A6F',
      'pink5': '#DA127D',
      'pink6': '#E8368F',
      'pink7': '#F364A2',
      'pink8': '#FF8CBA',
      'pink9': '#FFB8D2',
      'pink10': '#FFE3EC',
      'red1': '#610316',
      'red2': '#8A041A',
      'red3': '#AB091E',
      'red4': '#CF1124',
      'red5': '#E12D39',
      'red6': '#EF4E4E',
      'red7': '#F86A6A',
      'red8': '#FF9B9B',
      'red9': '#FFBDBD',
      'red10': '#FFE3E3',
      'yellow1': '#8D2B0B',
      'yellow2': '#B44D12',
      'yellow3': '#CB6E17',
      'yellow4': '#DE911D',
      'yellow5': '#F0B429',
      'yellow6': '#F7C948',
      'yellow7': '#FADB5F',
      'yellow8': '#FCE588',
      'yellow9': '#FFF3C4',
      'yellow10': '#FFFBEA',
      'teal1': '#014D40',
      'teal2': '#0C6B58',
      'teal3': '#147D64',
      'teal4': '#199473',
      'teal5': '#27AB83',
      'teal6': '#3EBD93',
      'teal7': '#65D6AD',
      'teal8': '#8EEDC7',
      'teal9': '#C6F7E2',
      'teal10': '#EFFCF6',
      'blue1': '#003E6B',
      'blue2': '#0A558C',
      'blue3': '#0F609B',
      'blue4': '#186FAF',
      'blue5': '#2680C2',
      'blue6': '#4098D7',
      'blue7': '#62B0E8',
      'blue8': '#84C5F4',
      'blue9': '#B6E0FE',
      'blue10': '#DCEEFB',

      // 'yellow1': '#8D2B0B',
      // 'yellow2': '#B44D12',
      // 'yellow3': '#CB6E17',
      // 'yellow4': '#DE911D',
      // 'yellow5': '#F0B429',
      // 'yellow6': '#F7C948',
      // 'yellow7': '#FADB5F',
      // 'yellow8': '#FCE588',
      // 'yellow9': '#FFF3C4',
      // 'yellow10': '#FFFBEA',

      'bluegrey1': '#102A43',
      'bluegrey2': '#243B53',
      'bluegrey3': '#334E68',
      'bluegrey4': '#486581',
      'bluegrey5': '#627D98',
      'bluegrey6': '#829AB1',
      'bluegrey7': '#9FB3C8',
      'bluegrey8': '#BCCCDC',
      'bluegrey9': '#D9E2EC',
      'bluegrey10': '#F0F4F8',

      'cyan1': '#044E54',
      'cyan2': '#0A6C74',
      'cyan3': '#0E7C86',
      'cyan4': '#14919B',
      'cyan5': '#2CB1BC',
      'cyan6': '#38BEC9',
      'cyan7': '#54D1DB',
      'cyan8': '#87EAF2',
      'cyan9': '#BEF8FD',
      'cyan10': '#E0FCFF',

      // 'red1': '#610404',
      // 'red2': '#780A0A',
      // 'red3': '#911111',
      // 'red4': '#A61B1B',
      // 'red5': '#BA2525',
      // 'red6': '#D64545',
      // 'red7': '#E66A6A',
      // 'red8': '#F29B9B',
      // 'red9': '#FACDCD',
      // 'red10': '#FFEEEE',
      
      'white': '#fff',
      'black': '#000',
      'dark-blue': '#0F609B',
      'light-blue': '#A1AEC9',
      'alert-green': '#346F25',
      'alert-red': '#D12424',
      'tekst-light': '#787878',
      // Core semantic surfaces
      bg: "hsl(var(--bg))",
      surface: "hsl(var(--surface))",
      "surface-2": "hsl(var(--surface-2))",
      "surface-3": "hsl(var(--surface-3))",
      card: "hsl(var(--card))",
      "card-bd": "hsl(var(--card-bd))",
      side: "hsl(var(--side))",
      "side-2": "hsl(var(--side-2))",
      avatar: "hsl(var(--avatar))",
      "chart-teal": "hsl(var(--chart-teal))",
      "chart-pred": "hsl(var(--chart-pred))",
      border: "hsl(var(--border))",
      "border-strong": "hsl(var(--border-strong))",

      // Text
      text: "hsl(var(--text))",
      "text-2": "hsl(var(--text-2))",
      "text-3": "hsl(var(--text-3))",
      "text-inverse": "hsl(var(--text-inverse))",

      // Brand / interaction
      primary: "hsl(var(--primary))",
      "primary-hover": "hsl(var(--primary-hover))",
      "primary-press": "hsl(var(--primary-press))",
      "primary-soft": "hsl(var(--primary-soft))",
      "primary-soft-strong": "hsl(var(--primary-soft-strong))",
      ring: "hsl(var(--ring))",

      // Financial status (muted, executive-safe)
      success: "hsl(var(--success))",
      "success-soft": "hsl(var(--success-soft))",
      warning: "hsl(var(--warning))",
      "warning-soft": "hsl(var(--warning-soft))",
      danger: "hsl(var(--danger))",
      "danger-soft": "hsl(var(--danger-soft))",
      info: "hsl(var(--info))",
      "info-soft": "hsl(var(--info-soft))",

      // Data viz tokens (keep color count restrained)
      chart: {
        1: "hsl(var(--chart-1))",
        2: "hsl(var(--chart-2))",
        3: "hsl(var(--chart-3))",
        grid: "hsl(var(--chart-grid))",
        axis: "hsl(var(--chart-axis))",
        band: "hsl(var(--chart-band))",
      },

      // Governance button system — filled-slate primary + neutral secondary, shared by
      // the approval / approval-policy / report-editor header actions. Plain hex (not
      // hsl-var) so opacity modifiers behave. Canonical usage: components/ui-components/buttonStyles.js
      "btn-slate": "#647084",        // primary fill / border
      "btn-slate-hover": "#556173",  // primary hover
      "btn-slate-active": "#465265", // primary pressed
      "btn-line": "#CBD5E1",         // secondary border
      "btn-line-hover": "#B6C2D4",   // secondary hover border
      "btn-line-active": "#AAB7CA",  // secondary pressed / focus border
      "btn-line-soft": "#E2E8F0",    // disabled border
      "btn-ink": "#334155",          // secondary text
      "btn-ink-hover": "#1E293B",    // secondary hover text
      "btn-ink-active": "#0F172A",   // secondary pressed text
      "btn-ink-soft": "#94A3B8",     // disabled text
      "btn-fill-hover": "#F8FAFC",   // secondary hover fill / disabled fill / primary disabled text
      "btn-fill-active": "#EEF2F7",  // secondary pressed fill
    },
    extend: {
      backgroundImage: {
        "gradient-ai": "linear-gradient(95deg, hsl(var(--chart-teal)), hsl(var(--chart-1)))",
        "bar-stripe": "repeating-linear-gradient(90deg, rgba(255,255,255,.18) 0 2px, transparent 2px 6px)",
      },
      keyframes: {
        shake: {
          "0%, 100%": { transform: "translateX(0)" },
          "25%": { transform: "translateX(-4px)" },
          "75%": { transform: "translateX(4px)" },
        },
        pulseScale: {
          "0%, 100%": { transform: "scale(1)" },
          "50%": { transform: "scale(1.01)" },
        },
      },
      animation: {
        shake: "shake 0.3s ease-in-out",
        "pulse-scale": "pulseScale 0.3s ease-in-out",
      },
    },
  },
  plugins: [],
}
